import Alert from 'common/components/core/Alert'
import { pageTypes } from 'common/constants/pageTypes'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useManagement, {
  selectors as managementSelectors,
} from '../../hooks/useManagement'
import usePage, { selectors as pageSelectors } from '../../hooks/usePage'

export const PreviewBanner = () => {
  const isPreview = useManagement(managementSelectors.isPreviewMode)
  const pageType = usePage(pageSelectors.getPageType)
  const { t } = useTranslation(['publisher'])
  const [labelText, setLabelText] = useState('')
  const isPreviewAndNotRemoteFormAndPopup =
    isPreview && ![pageTypes.inline, pageTypes.popup].includes(pageType)

  useEffect(() => {
    setLabelText(t('components.preview.warning'))
  }, [])

  return isPreviewAndNotRemoteFormAndPopup ? (
    <Alert type="warning">{labelText}</Alert>
  ) : null
}
